import { EMAIL_KIND_PRE_ARCHIVE_UPLOAD, type Project } from '@/api/client';
import { ProjectEmailModal } from './ProjectEmailModal';

export type PreArchiveUploadEmailModalMode = 'status_transition' | 'email_only';

export interface PreArchiveUploadEmailModalProps {
  open: boolean;
  onClose: () => void;
  project: Project;
  mode: PreArchiveUploadEmailModalMode;
  intendedState?: string;
}

export function PreArchiveUploadEmailModal({
  open,
  onClose,
  project,
  mode,
  intendedState,
}: PreArchiveUploadEmailModalProps) {
  return (
    <ProjectEmailModal
      open={open}
      onClose={onClose}
      project={project}
      emailKind={EMAIL_KIND_PRE_ARCHIVE_UPLOAD}
      modalTitle={`Загружен в предархив: ${project.name ?? 'Проект'}`}
      requireNewState={mode === 'status_transition'}
      newStateWhenSaving={mode === 'status_transition' ? intendedState : undefined}
    />
  );
}
